// src/OneLoginHelper.ts
import {SigninRedirectArgs, SigninSilentArgs, User, UserManager, WebStorageStateStore} from "oidc-client-ts";


const response_type = "code";
const scope = "openid profile email";

export const mgr = new UserManager({
    authority:     process.env.REACT_APP_OIDC_ISSUER!,
    client_id:      process.env.REACT_APP_OIDC_CLIENT_ID!,
    redirect_uri:   `${window.location.origin}/auth-callback`,
    response_type:  response_type,
    scope:         scope,
    post_logout_redirect_uri: `${window.location.origin}/`,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
});

export function login(returnUrl?: string) {
    // Pass returnUrl through the state parameter
    const args: SigninRedirectArgs = returnUrl ? { state: returnUrl } : {};
    return mgr.signinRedirect(args);
}

export function loginSilent(returnUrl?: string) {
    // Pass returnUrl through the state parameter
    const args: SigninSilentArgs =  returnUrl ? { state: returnUrl } : {};
    return mgr.signinSilent(args);
}

export function logout() {
    return mgr.signoutRedirect();
}

export async function handleCallback() {
    return await mgr.signinRedirectCallback();
}

export async function signinSilentCallback() {
    return await mgr.signinSilentCallback();
}

export async function getAccessToken(): Promise<string|undefined> {
    const user = await mgr.getUser();
    return user?.access_token;
}

export async function getOneLoginUser(): Promise<User|null> {
    return await mgr.getUser();
}

export async function removeUser(){
    return await mgr.removeUser();
}

export function getUserManager(){
    return mgr;
}
